import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, SearchIcon, PenToolIcon, BarChart2Icon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { buildBreadcrumbList } from '../lib/structuredData';
export const TeamLid2Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2488" data-mp="1p3ad0rg0s5ze">
      <SEO title="Beer, SEO-specialist en vormgever | Noord Digital" description="Maak kennis met Beer van Noord Digital. Hij zorgt voor organische vindbaarheid en is de ontwerper achter onze huisstijlen en vormgeving." keywords="beer noord digital, seo specialist, vormgever Noord-Holland, huisstijl ontwerper" canonical="https://noorddigital.nl/over-ons/beer" jsonLd={buildBreadcrumbList([{
      name: 'Over ons',
      path: '/over-ons'
    }, {
      name: 'Beer',
      path: '/over-ons/beer'
    }])} data-id="element-2489" data-mp="1u36gmpkt1vef" />
      <Header data-id="element-2490" data-mp="2nr97kjhbzv" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2491" data-mp="374wc35pe83">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2492" data-mp="3r8fbjqbmxuer">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2493" data-mp="3r748jsq0kqop">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2494" data-mp="3i8agmfnmoohh" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2495" data-mp="isdtugujn22c">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2496" data-mp="iuq74gpcwo92">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2497" data-mp="erk73qsu7tb1">
                <img src="https://cdn.magicpatterns.com/uploads/3h5jPU9M1S7oTcbxfUFYhr/image.png" alt="Beer" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2498" data-mp="9y7ivhs2loit" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2499" data-mp="xov4t6ytmeod">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2500" data-mp="xntfbxh25pn4">
                Beer
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2501" data-mp="1ll85rkfjx5f2">
                SEO Specialist
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2502" data-mp="17ucvq4tbgi9w">
                <p className="mb-4" data-id="element-2503" data-mp="17s0ddqjnc5wb">
                  Als SEO Specialist bij Noord Digital ben ik verantwoordelijk
                  voor de organische vindbaarheid van onze klanten. Mijn doel is
                  niet alleen om websites hoger in Google te krijgen, maar
                  vooral om de juiste, koopgerichte bezoekers aan te trekken.
                </p>
                <p className="mb-4" data-id="element-2504" data-mp="owjsf1es66bz">
                  Ik duik diep in de data om te begrijpen waar de doelgroep naar
                  zoekt en welke intentie daarachter zit. Op basis daarvan bouw
                  ik ijzersterke SEO-structuren en contentstrategieën die op de
                  lange termijn structureel leads opleveren.
                </p>
                <p data-id="element-2505" data-mp="bmqc472pnat0">
                  Mijn werkwijze kenmerkt zich door een technische basis
                  gecombineerd met sterke, relevante content. Ik geloof dat SEO
                  geen trucje is, maar het bouwen van de beste antwoorden op de
                  vragen van je potentiële klanten.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2506" data-mp="gl06ifgm27dk">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2507" data-mp="vdbqx7kyifbw">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2508" data-mp="qbmf3ppwtxmr">
                  <SearchIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2509" data-mp="14am797cmsuno" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2510" data-mp="zcaykzy2oq71">SEO Strategie</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2511" data-mp="362qu44f9x1rj">
                  <PenToolIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2512" data-mp="314fibo5f4h6o" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2513" data-mp="316a8phzgl1i5">
                    Content Marketing
                  </h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2514" data-mp="37jo5mi4sp5bo">
                  <BarChart2Icon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2515" data-mp="3cjsdjjrn0rqa" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2516" data-mp="3chpob1yb72mm">Keyword Research</h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2517" data-mp="2jv4yi5xheyl6">
                Neem contact op met Beer
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2518" data-mp="2tr7vyyhe291s" />
    </div>;
};